import type { CtrlChainIcons } from '@cca-ui/icon';

export const DocGroup = {
  GettingStarted: 'Getting started',
  Resources: 'Resources',
} as const;

export type DocGroup = (typeof DocGroup)[keyof typeof DocGroup];

export interface DocHeadingBlock {
  readonly kind: 'heading';
  readonly text: string;
}

export interface DocParagraphBlock {
  readonly kind: 'paragraph';
  readonly text: string;
}

export interface DocCodeBlock {
  readonly kind: 'code';
  readonly language: string;
  readonly code: string;
}

export interface DocCalloutBlock {
  readonly kind: 'callout';
  readonly text: string;
}

export interface DocListBlock {
  readonly kind: 'list';
  readonly items: readonly string[];
}

export interface DocTableBlock {
  readonly kind: 'table';
  readonly headers: readonly string[];
  readonly rows: readonly (readonly string[])[];
}

export type DocBlock =
  | DocHeadingBlock
  | DocParagraphBlock
  | DocCodeBlock
  | DocCalloutBlock
  | DocListBlock
  | DocTableBlock;

export interface DocPage {
  readonly id: string;
  readonly group: DocGroup;
  readonly title: string;
  readonly lead: string;
  readonly blocks: readonly DocBlock[];
}

export type HttpMethod = 'GET' | 'POST' | 'PATCH' | 'DELETE';

export interface ApiEndpointParameter {
  readonly name: string;
  readonly type: string;
  readonly required: boolean;
  readonly description: string;
}

export interface ApiEndpoint {
  readonly id: string;
  readonly group: string;
  readonly method: HttpMethod;
  readonly path: string;
  readonly examplePath: string;
  readonly title: string;
  readonly description: string;
  readonly parametersTitle: string;
  readonly parameters: readonly ApiEndpointParameter[];
  readonly requestBody: object | null;
  // null for endpoints that return a file instead of a JSON body
  readonly response: object | null;
  readonly responseStatus?: string;
  readonly returns: string;
}

export interface ApiResource {
  readonly name: string;
  readonly icon: CtrlChainIcons;
  readonly description: string;
  readonly docId: string;
  readonly firstEndpointId: string;
}
